/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Blank_Dmca_AgentInputs */

const en_legal_blank_dmca_agent = /** @type {(inputs: Legal_Blank_Dmca_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[designated agent: to be added]`)
};

const pl_legal_blank_dmca_agent = /** @type {(inputs: Legal_Blank_Dmca_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[wyznaczony pełnomocnik: do uzupełnienia]`)
};

/**
* | output |
* | --- |
* | "[designated agent: to be added]" |
*
* @param {Legal_Blank_Dmca_AgentInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_blank_dmca_agent = /** @type {((inputs?: Legal_Blank_Dmca_AgentInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Blank_Dmca_AgentInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_blank_dmca_agent(inputs)
	return en_legal_blank_dmca_agent(inputs)
});